import React from "react";
import mainContext from "./mainContext";
import { useState, useEffect } from "react";
import { Select, Button, DatePicker } from "antd";

const { RangePicker } = DatePicker;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const MainState = (props) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [activeTab, setActiveTab] = useState("1"); // State to keep track of active tab
  const [proposalsP, setProposalsP] = useState(); //P as in pending
  const [proposalsA, setProposalsA] = useState(); //A as in Accepted
  const [inventories, setInventories] = useState(null);
  const [selectedInv, setSelectedInv] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [fetchProp, setFetchProp] = useState(false); //this basically tells whether to fetch the proposals based on toggle
  const [activatePR, setActivatePR] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [sendingLoader, setSendingLoader] = useState(false);
  const [createdOptions, setCreatedOptions] = useState(null);
  const [clientOptions, setClientOptions] = useState(null);
  const [dates, setDates] = useState(null);
  const [emailProps, setEmailProps] = useState({});
  const [filtersProposal, setFiltersProposal] = useState({
    client: null,
    createdBy: null,
    dateRange: null,
  });
  const [paginationAccepted, setPaginationAccepted] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [paginationPending, setPaginationPending] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loadingAccepted, setLoadingAccepted] = useState(false);
  const [loadingPending, setLoadingPending] = useState(false);

  async function fetchProposals(type) {
    try {
      // Set loading state based on type
      if (type === "accepted") {
        setLoadingAccepted(true);
      } else if (type === "pending") {
        setLoadingPending(true);
      }

      let query = [];

      if (filtersProposal.client) {
        query.push(`client=${filtersProposal.client}`);
      }

      if (filtersProposal.createdBy) {
        query.push(`createdBy=${filtersProposal.createdBy}`);
      }

      if (
        filtersProposal.dateRange &&
        filtersProposal.dateRange[0] &&
        filtersProposal.dateRange[1]
      ) {
        query.push(`startDate=${filtersProposal.dateRange[0]}`);
        query.push(`endDate=${filtersProposal.dateRange[1]}`);
      }

      // Add type filter
      query.push(`type=${type}`);

      // Add pagination parameters based on type
      let pagination, setPagination, setProposals;
      if (type === "accepted") {
        pagination = paginationAccepted;
        setPagination = setPaginationAccepted;
        setProposals = setProposalsA;
      } else if (type === "pending") {
        pagination = paginationPending;
        setPagination = setPaginationPending;
        setProposals = setProposalsP;
      }

      const skip = (pagination.current - 1) * pagination.pageSize;
      query.push(`limit=${pagination.pageSize}`);
      query.push(`skip=${skip}`);

      const queryString = query.length > 0 ? `?${query.join("&")}` : "";

      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/allProposals${queryString}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let data = await response.json();

      // Update pagination info if available
      if (data.pagination) {
        setPagination((prev) => ({
          ...prev,
          total: data.pagination.total,
        }));
      }

      setProposals(data.data);
    } catch (err) {
      console.error(`Error fetching ${type} proposals: `, err.message);
    } finally {
      // Clear loading state based on type
      if (type === "accepted") {
        setLoadingAccepted(false);
      } else if (type === "pending") {
        setLoadingPending(false);
      }
    }
  }

  const handleFiltering = (value, filterType) => {
    setFiltersProposal((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));
    setPaginationAccepted((prev) => ({
      ...prev,
      current: 1,
    }));
    setPaginationPending((prev) => ({
      ...prev,
      current: 1,
    }));
  };

  const handleDateChange = (dates, dateStrings) => {
    setDates(dates);
    setFiltersProposal((prevFilters) => ({
      ...prevFilters,
      dateRange: dateStrings,
    }));
    setPaginationAccepted((prev) => ({
      ...prev,
      current: 1,
    }));
    setPaginationPending((prev) => ({
      ...prev,
      current: 1,
    }));
  };

  const handleClearFilters = () => {
    setDates(null);
    setFiltersProposal({
      client: null,
      createdBy: null,
      dateRange: null,
    });
    setPaginationAccepted((prev) => ({
      ...prev,
      current: 1,
    }));
    setPaginationPending((prev) => ({
      ...prev,
      current: 1,
    }));
  };

  const handlePaginationChangeAccepted = (page, pageSize) => {
    setPaginationAccepted((prev) => ({
      ...prev,
      current: page,
      pageSize: pageSize,
    }));
  };

  const handlePaginationChangePending = (page, pageSize) => {
    setPaginationPending((prev) => ({
      ...prev,
      current: page,
      pageSize: pageSize,
    }));
  };

  const filters = [
    {
      key: "1",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Created By </h6>
          <Select
            showSearch
            allowClear
            value={filtersProposal.createdBy}
            style={{
              width: 200,
            }}
            placeholder="Client Name"
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            options={createdOptions}
            onChange={(value) => handleFiltering(value, "createdBy")}
          />
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Client </h6>
          <Select
            showSearch
            allowClear
            value={filtersProposal.client}
            style={{
              width: 200,
            }}
            placeholder="Client Name  "
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            options={clientOptions}
            onChange={(value) => handleFiltering(value, "client")}
          />
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Date Range </h6>
          <RangePicker onChange={handleDateChange} value={dates} />
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <Button
          onClick={(e) => handleClearFilters()}
          style={{ fontSize: "12px" }}
        >
          Clear
        </Button>
      ),
    },
  ];

  return (
    <mainContext.Provider
      value={{
        activeTab,
        setActiveTab,
        proposalsA,
        setProposalsA,
        proposalsP,
        setProposalsP,
        inventories,
        setInventories,
        selectedInv,
        setSelectedInv,
        proposalId,
        setProposalId,
        fetchProp,
        setFetchProp,
        activatePR,
        setActivatePR,
        showLoader,
        setShowLoader,
        createdOptions,
        setCreatedOptions,
        clientOptions,
        setClientOptions,
        dates,
        setDates,
        emailProps,
        setEmailProps,
        filtersProposal,
        setFiltersProposal,
        paginationAccepted,
        setPaginationAccepted,
        paginationPending,
        setPaginationPending,
        loadingAccepted,
        setLoadingAccepted,
        loadingPending,
        setLoadingPending,
        fetchProposals,
        handleFiltering,
        handleDateChange,
        handleClearFilters,
        handlePaginationChangeAccepted,
        handlePaginationChangePending,
        filters,
        apiBaseUrl,
        sendingLoader,
        setSendingLoader,
      }}
    >
      {props.children}
    </mainContext.Provider>
  );
};

export default MainState;
